// import base&&tool
import 'whatwg-fetch';
import 'scss_mixin/reset.scss'; // reset 样式
import 'tools/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import {
    HashRouter as Router,
    Route,
    Switch,
    Redirect,
    withRouter,
} from 'react-router-dom';

import Loadable from 'react-loadable';
import PageLoading from 'commons/PageLoading';
import LoadPassportJs from './components/LoadPassportJs';


// scrollToTop 路由切换时候页面默认滚动到顶部，可在此控件中配置白名单
import ScrollToTop from 'commons/ScrollToTop';

// import containers
// import processOnterHook from './router/RouterRenderBeforeHandle';

// 异步加载文件 参考文档 https://webpack.js.org/guides/code-splitting/#dynamic-imports
// 参数中的注释部分不建议删除，原因请看上述文档
// const Login = Loadable({
//     loader: () => import('./containers/Login/Login' /* webpackChunkName:"Login" */),
//     loading: PageLoading,
// });
const Superiority = Loadable({
    loader: () => import('./containers/Superiority/Superiority' /* webpackChunkName:"Superiority" */),
    loading: PageLoading,
});

// 主页面路由
class MainRouterPack extends React.PureComponent {
    render() {
        return (
            <div className="lm-ui-content clearfix">
                <ScrollToTop>
                    <Switch>
                        {/* 宣传登录页 */}
                        {/* <Route */}
                        {/*    path="/login" */}
                        {/*    component={Login} */}
                        {/* /> */}
                        <Route
                            path="/superiority"
                            component={Superiority}
                        />
                        <Redirect to="/superiority" />
                    </Switch>
                </ScrollToTop>
            </div>
        );
    }
}
const MainRouter = withRouter(MainRouterPack);

const rootRender = () => {
    const rootElement = document.getElementById('root');
    ReactDOM.render(
        <Router>
            <MainRouter />
        </Router>,
        rootElement
    );
};


// 进入页面之前先请求导流接口，看需要往哪跳转
// 0（成功），1（失败），2（未登录），3（未实名）
LoadPassportJs(() => {
    rootRender();
});




// WEBPACK FOOTER //
// ./src/pages/ground/index.js